import isEqual from "lodash/isEqual";

const initialLocation = { new: true, sub_qty: 0 };

export const getInitialLocation = (qty, shipmentId) => {
  const values = { ...initialLocation };

  if (qty) {
    values.restock_sub_qty = qty;
  }

  if (shipmentId) {
    values.shipment_id = shipmentId;
  }

  return values;
};

export const getFormattedLocations = (values, isWarehouseRestockModalEnabled) => {
  const getSubQty = location =>
    location.restock_sub_qty ? location.restock_sub_qty + location.sub_qty : location.sub_qty;

  return values.locations.map(location => {
    const formattedLocation = {
      entry_uid: location.entry_uid,
      sub_qty: getSubQty(location),
      allocated_quantity: location.allocated_quantity ?? 0,
    };

    if (isWarehouseRestockModalEnabled) {
      // Send full nested objects - no backend hydration needed
      formattedLocation.warehouse = {
        id: location.warehouse?.id,
        warehouse_id: location.warehouse?.warehouseId || location.warehouse?.warehouse_id,
        name: location.warehouse?.name,
      };

      // warehouse_locations is now an array - support both old and new formats
      if (location.warehouse_location) {
        // Old format: convert single location to array
        formattedLocation.warehouse_locations = [{
          id: location.warehouse_location?.id,
          location_id: location.warehouse_location?.locationId || location.warehouse_location?.location_id,
          location_name: location.warehouse_location?.locationName || location.warehouse_location?.location_name,
        }];
      } else if (location.warehouse_locations) {
        // New format: already an array
        formattedLocation.warehouse_locations = location.warehouse_locations;
      } else {
        formattedLocation.warehouse_locations = [];
      }

      if (location.mobile_warehouse_location?.id) {
        formattedLocation.mobile_warehouse_location = {
          id: location.mobile_warehouse_location.id,
          location_id: location.mobile_warehouse_location.locationId || location.mobile_warehouse_location.location_id,
          location_name: location.mobile_warehouse_location.locationName || location.mobile_warehouse_location.location_name,
        };
      }
    }

    if (location.shipment_id) {
      formattedLocation.shipment_id = location.shipment_id;
    }

    return formattedLocation;
  });
};

export const getOldRackLocations = locations => {
  return locations.map(v => {
    const location = {
      entry_uid: v.entry_uid,
      warehouse: {
        id: v.warehouse?.id,
        warehouse_id: v.warehouse?.warehouseId || v.warehouse?.warehouse_id,
        name: v.warehouse?.name,
      },
      warehouse_locations: v.warehouse_locations || [],
      sub_qty: v.sub_qty,
      allocated_quantity: v.allocated_quantity ?? 0,
    };

    if (v.mobile_warehouse_location?.id) {
      location.mobile_warehouse_location = {
        id: v.mobile_warehouse_location.id,
        location_id: v.mobile_warehouse_location.locationId || v.mobile_warehouse_location.location_id,
        location_name: v.mobile_warehouse_location.locationName || v.mobile_warehouse_location.location_name,
      };
    }

    if (v.shipment_id) {
      location.shipment_id = v.shipment_id;
    }

    return location;
  });
};

const locationsMatch = (left, right) => {
  if (left.entry_uid && right.entry_uid) {
    return left.entry_uid === right.entry_uid;
  }

  const leftWarehouseLocationIds = (left.warehouse_locations || []).map(loc => loc.id).filter(Boolean);
  const rightWarehouseLocationIds = (right.warehouse_locations || []).map(loc => loc.id).filter(Boolean);
  const leftMobileLocationId = left.mobile_warehouse_location?.id;
  const rightMobileLocationId = right.mobile_warehouse_location?.id;
  const leftShipmentId = left.shipment_id || "";
  const rightShipmentId = right.shipment_id || "";

  const hasMatchingLocation = leftWarehouseLocationIds.some(id => rightWarehouseLocationIds.includes(id));

  return hasMatchingLocation &&
    leftMobileLocationId === rightMobileLocationId &&
    leftShipmentId === rightShipmentId;
};

export const getRackLocationsChanges = (locations, oldLocations) => {
  return locations
    .filter(v => {
      if (v.restock_sub_qty) return true;

      return !oldLocations.some(loc => locationsMatch(v, loc));
    })
    .map(v => {
      const location = {
        entry_uid: v.entry_uid,
        sub_qty: v.restock_sub_qty || 0,
        warehouse: {
          id: v.warehouse?.id,
          warehouse_id: v.warehouse?.warehouseId || v.warehouse?.warehouse_id,
          name: v.warehouse?.name,
        },
        warehouse_locations: v.warehouse_location ? [{
          id: v.warehouse_location?.id,
          location_id: v.warehouse_location?.locationId || v.warehouse_location?.location_id,
          location_name: v.warehouse_location?.locationName || v.warehouse_location?.location_name,
        }] : (v.warehouse_locations || []),
      };

      if (v.mobile_warehouse_location?.id) {
        location.mobile_warehouse_location = {
          id: v.mobile_warehouse_location.id,
          location_id: v.mobile_warehouse_location.locationId || v.mobile_warehouse_location.location_id,
          location_name: v.mobile_warehouse_location.locationName || v.mobile_warehouse_location.location_name,
        };
      }

      if (v.shipment_id) {
        location.shipment_id = v.shipment_id;
      }

      return location;
    });
};
